"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const index_1 = require("../index");
const SwitchContainer_1 = __importDefault(require("../../Cell/components/switch/SwitchContainer"));
const StatusIndicator_1 = require("../../styled/StatusIndicator");
const util_1 = require("../../../util");
const Stringify_1 = require("../../Cell/components/Stringify");
var ICONS;
(function (ICONS) {
    ICONS["STAGE_DEPLOY"] = "stage-deploy";
})(ICONS = exports.ICONS || (exports.ICONS = {}));
exports.ActionColumn = ({ actions, column, row, colIndex, rowIndex, label, actionDispatcher, className, tooltip, }) => {
    const actionCreator = {
        colIndex,
        rowIndex,
        column,
        row,
    };
    const onAction = (props) => {
        actionDispatcher({
            ...props,
            creator: { row, column, rowIndex, colIndex },
        });
    };
    const stageDeployAction = actions.find((act) => act.icon === ICONS.STAGE_DEPLOY);
    const onStageDeployAction = () => {
        stageDeployAction &&
            onAction({
                ...stageDeployAction,
                action: stageDeployAction.type,
                disabled: util_1.convertSerializedIntoJS(stageDeployAction.disabled, row, column),
            });
    };
    const otherActions = actions
        .filter((act) => act.icon !== ICONS.STAGE_DEPLOY)
        .map((action) => ({
        ...action,
        disabled: util_1.convertSerializedIntoJS(action.disabled, row, column),
    }));
    const id = `super-table-action-dropdown-row-${rowIndex}-col-${colIndex}`;
    return (react_1.default.createElement(react_1.default.Fragment, null, row.loading === column.id ? (react_1.default.createElement(index_1.Loader, { row: row, col: column })) : (react_1.default.createElement(react_1.default.Fragment, null,
        tooltip && (react_1.default.createElement(reactstrap_1.UncontrolledTooltip, { target: id },
            react_1.default.createElement(Stringify_1.Stringify, { col: column, value: tooltip }))),
        react_1.default.createElement(reactstrap_1.UncontrolledDropdown, { id: id, className: "" },
            react_1.default.createElement(reactstrap_1.DropdownToggle, { caret: Boolean(label), size: "sm", className: `${!label ? "super-table-action-dropdown" : ""} ${className || ""} text-truncate`, color: label ? "primary" : "link" }, label ? (react_1.default.createElement(Stringify_1.Stringify, { col: column, value: label })) : (react_1.default.createElement("i", { className: "fa fa-ellipsis-v" }))),
            react_1.default.createElement(reactstrap_1.DropdownMenu, { right: true },
                otherActions.map((action) => (react_1.default.createElement(reactstrap_1.DropdownItem, { key: JSON.stringify(action), className: "cursor-pointer", disabled: action.disabled, onClick: () => onAction({ ...action, action: action.type }) },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement("i", { className: `fa ${action.icon} mr-2` }, " ")),
                    react_1.default.createElement(Stringify_1.Stringify, { col: column, value: action.label })))),
                stageDeployAction && react_1.default.createElement(reactstrap_1.DropdownItem, { divider: true }),
                stageDeployAction && (react_1.default.createElement(reactstrap_1.DropdownItem, { disabled: true },
                    react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center text-uppercase" },
                        react_1.default.createElement(StatusIndicator_1.SwitchStatus, null, "Stage"),
                        react_1.default.createElement("div", { className: "px-2" },
                            react_1.default.createElement(SwitchContainer_1.default, { "data-test": "super-table-action-switch", value: row.active, disabled: stageDeployAction.disabled, onChange: onStageDeployAction })),
                        react_1.default.createElement(StatusIndicator_1.SwitchStatus, null, "Deploy"))))))))));
};
//# sourceMappingURL=ActionColumn.js.map